module.exports = __webpack_public_path__ + "img/SafetyDividerOutlined.d9ce9ddf.svg";